import React, { Component } from 'react';
import axios from 'axios';
import { Form, Row, Col, Icon, Input, Button, Slider, message } from 'antd';
const FormItem = Form.Item;

//This is the SignUp component that heavily utilizes
//The ant design UI library's Form Component
//Which has also integrated a validation library
class SignUp extends Component {
  handleSubmit(e){
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        axios.put('/auth/register', {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          password: values.password,
          age: values.age,
        }).then((res) => {
          if(res.data === 'taken'){
            message.error("Email Taken");
          } else{
            this.loginUser(values.email, values.password);
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    });
  }

  loginUser(email, password){
    const {fetchUser} = this.props;
    axios.post('/auth/login', {
      email: email,
      password: password
    }).then(function(response) {
      message.success("You are now logged in.");
      fetchUser();
    }).catch(err => {
      message.error(err.message);
    });
  }

  //These are some regex patterns used to validate two fields
  regex = {
    email: /^[a-zA-Z0-9]([._](?![._])|[a-zA-Z0-9]){4,14}[a-zA-Z0-9]$/,
    password: /^(?=.*[A-Za-z])(?=.*\d)|(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/
  }

  render() {
    //This is from a validation library, passed in when wrapped
    //The decorator functions binds the fields and passes the regex patterns/message
    const { getFieldDecorator } = this.props.form;
    return (
      <div id="SignUp">
        <Form className="signup-form" onSubmit={this.handleSubmit.bind(this)}>
          <FormItem>
            {getFieldDecorator('email', {
              rules: [{ type: 'email', message: 'This is not a valid email' }, {
                required: true, message: 'Please enter an email address',
              }],
            })(
              <Input prefix={<Icon type="login" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Email" />
            )}
          </FormItem>
          <Row>
            <Col span={12}>
              <FormItem>
                {getFieldDecorator('firstName', {
                  rules: [{ max: 35, message: 'Max character length exceeded' }],
                })(
                  <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="First" />
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem>
              {getFieldDecorator('lastName', {
                rules: [{ max: 35, message: 'Max character length exceeded' }],
              })(
                <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Last" />
              )}
              </FormItem>
            </Col>
          </Row>
          <FormItem>
            {getFieldDecorator('password', {
              rules: [{ max: 40, pattern: this.regex.password, message: '8-40 length. At least one letter and one number or symbol' }, {
                required: true, message: 'Please enter a password',
              }],
            })(
              <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Password" />
            )}
          </FormItem>
          <h3>Age</h3>
          <FormItem
            className="age-slider"
            >
            {getFieldDecorator('age', {
              rules: [{ required: true, message: 'Age is required'}]
            })(
              <Slider
                max={125}
                min={1}
                type="Age"
                />
            )}
          </FormItem>
          
          <Button icon="to-top" type="primary" htmlType="submit">
            Register
          </Button>
        </Form>
      </div>
    );
  }
}

//Wrap the form so you can use the validation libraries
const WrappedForm = Form.create()(SignUp);

export default WrappedForm;



// WEBPACK FOOTER //
// ./src/components/Site/SignUpForm.js